export class AppError extends Error {
  constructor(message, code, originalError) {
    super(message);
    this.name = "AppError";
    this.code = code;
    this.originalError = originalError;
  }
}

export const ErrorCodes = {
  AUTH_REQUIRED: "auth/required",
  STORAGE_UNAUTHORIZED: "storage/unauthorized",
  STORAGE_NOT_FOUND: "storage/not-found",
  NETWORK_ERROR: "network/error",
  FIRESTORE_NODATA: "firestore/no-data",
  FIRESTORE_DATA_INCOMPLETE: "firestore/data-incomplete",
  DOCUMENT_NOT_FOUND: "firestore/document-not-found",
  INVALID_INPUT: "validation/invalid-input",
  UNKNOWN_ERROR: "unknown/error",
};

export const handleError = (error) => {
  if (error instanceof AppError) {
    return error;
  }

  // Handle Firebase errors
  if (error.code) {
    switch (error.code) {
      case "storage/unauthorized":
        return new AppError(
          "You don't have permission to access this resource",
          ErrorCodes.STORAGE_UNAUTHORIZED,
          error
        );
      case "storage/object-not-found":
        return new AppError(
          "The requested resource was not found",
          ErrorCodes.STORAGE_NOT_FOUND,
          error
        );
      default:
        return new AppError(
          error.message || "An unknown error occurred",
          ErrorCodes.UNKNOWN_ERROR,
          error
        );
    }
  }

  // Handle network errors
  if (error.message?.includes("Network Error")) {
    return new AppError(
      "Network error occurred. Please check your connection.",
      ErrorCodes.NETWORK_ERROR,
      error
    );
  }

  return new AppError(
    error.message || "An unknown error occurred",
    ErrorCodes.UNKNOWN_ERROR,
    error
  );
};
